
/*
 *  Manage paymentez app code & key modal dialog
 */
angular.module('qkr').controller('PaymentezAppKeyCodeController', ($scope, $http, $uibModalInstance, appConfig,
                                                                   merchantForm) => {

    $scope.saving = false;
    $scope.form = {};
    $scope.merchantForm = merchantForm;
    $scope.appkey = merchantForm.appkey;
    $scope.appcode = merchantForm.appcode;

    const init = function() {};

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    },

    $scope.ok = function() {
        const createCommand = {appKey: appkey.value, appCode: appcode.value, merchantName: merchantForm.storeFrontName};
        const success = $http.post(appConfig.apiUrl + 'merchant/updateAppKeyAppCode', createCommand);
        $uibModalInstance.close('ok');
    };
    init();
});



// WEBPACK FOOTER //
// ./src/controllers/modal/paymentez.appkeycode.controller.js